import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import mapstyle from "./modules/mapstyle"
 Vue.use(Vuex);
const debug=process.env.NODE_ENV!=='production';

export default new Vuex.Store({
  modules:{
    user,
    mapstyle,
  },
  strict:false
})



// WEBPACK FOOTER //
// ./src/vuex/store.js